var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack209({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.21,10.54l1.59-.18a1.15,1.15,0,0,0,.31.72.88.88,0,0,0,.65.23,1,1,0,0,0,.86-.46A4,4,0,0,0,9.08,8.9a2,2,0,0,1-1.55.72,2.32,2.32,0,0,1-1.75-.78A2.86,2.86,0,0,1,5,6.8a2.87,2.87,0,0,1,.78-2.1,2.62,2.62,0,0,1,2-.8,2.64,2.64,0,0,1,2.14,1,5.19,5.19,0,0,1,.84,3.32,5.3,5.3,0,0,1-.87,3.4,2.81,2.81,0,0,1-2.28,1A2.41,2.41,0,0,1,6,12.14,2.62,2.62,0,0,1,5.21,10.54Zm3.72-3.6A1.91,1.91,0,0,0,8.57,5.7a1.11,1.11,0,0,0-.85-.44A1,1,0,0,0,7,5.62a1.86,1.86,0,0,0-.3,1.18A1.84,1.84,0,0,0,7,8a1,1,0,0,0,.82.39A1,1,0,0,0,8.61,8,1.62,1.62,0,0,0,8.93,6.94Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack209);
export default __webpack_public_path__ + "static/media/Symbolpack_2_09.3409739c68caa3bdecc0d343fb47ad64.svg";
export { ForwardRef as ReactComponent };